import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { IBaseRequestParams } from '../../../../store/types/Request.types';

import { IProspects, IRequiredAction, IRequiredActionsValidateParams } from './requiredActions.types';

const PREFIX = 'RECIPIENT/REQUIRED_ACTIONS';

export const loadRequiredActionsRequest = createAction<IBaseRequestParams>(`${PREFIX}/LOAD_REQUIRED_ACTIONS_REQUEST`);
export const loadRequiredActionsSuccess = createAction<IRequiredAction[]>(`${PREFIX}/LOAD_REQUIRED_ACTIONS_SUCCESS`);
export const loadRequiredActionsFail = createAction<TLegacyErrors>(`${PREFIX}/LOAD_REQUIRED_ACTIONS_FAIL`);

export const validateProspectsRequest = createAction<IRequiredActionsValidateParams>(
  `${PREFIX}/VALIDATE_PROSPECTS_REQUEST`,
);
export const validateProspectsSuccess = createAction<IProspects>(`${PREFIX}/VALIDATE_PROSPECTS_SUCCESS`);
export const validateProspectsFail = createAction<TLegacyErrors<IProspects>>(`${PREFIX}/VALIDATE_PROSPECTS_FAIL`);

export const resetErrors = createAction<void>(`${PREFIX}/RESET_ERRORS`);
export const resetProspects = createAction<void>(`${PREFIX}/RESET_PROSPECTS`);
